import { Icon } from '@chakra-ui/react';

export default function SFPlayCircleIcon(props) {
  return (
    <Icon
      width='24'
      height='24'
      fill='currentColor'
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M12 20.328c-4.352 0-7.969-3.617-7.969-7.969 0-4.359 3.61-7.968 7.961-7.968 4.36 0 7.977 3.609 7.977 7.968 0 4.352-3.61 7.97-7.969 7.97M12 19a6.615 6.615 0 0 0 6.64-6.64 6.62 6.62 0 0 0-6.648-6.641 6.6 6.6 0 0 0-6.625 6.64A6.61 6.61 0 0 0 12 19m-1.46-3.586c-.368.219-.782.04-.782-.336v-5.43c0-.382.445-.53.781-.335l4.445 2.632a.48.48 0 0 1 0 .836z' />
    </Icon>
  );
}
